import { Component, OnInit, OnDestroy } from '@angular/core';
import Utils from './shared/utilerias/utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  router: any;

  constructor() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  ngOnInit() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }
  

  ngOnDestroy() {
     window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  handleBeforeUnload = (event: BeforeUnloadEvent): void => {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      const token = parsedUser?.token;

      if (token) {
        console.log('Sending request to logout');
        if(token == null || token == "" )
            return;
        
        const url = `${Utils.getBaseUrlApiWeb()}/users/logout`;
        console.log('URL:', url);
        
        const body = {
          Username: 'tr',  // Usa las propiedades correctas
          Password: 'tr',  // Usa las propiedades correctas
          Token: token
        };

        // Usamos fetch para enviar los datos como JSON
        localStorage.removeItem('currentUser');
   
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',  // Asegúrate de que sea application/json
          },
          body: JSON.stringify(body)  // Convierte el cuerpo a JSON
        })

        .catch(err => {
          console.error('Logout failed:', err);
        }).finally(() => {
          console.log('Logout successful');
          // Limpiar el almacenamiento local después de logout exitoso
          this.router.navigate(['/login']);
        }
      )}
    }

    event.returnValue = '';  // Necesario para algunos navegadores
  };
}
